import { Link } from "wouter";

declare const __APP_ENV__: string;
declare const __APP_VERSION__: string;
declare const __BUILD_SHA__: string;
declare const __BUILD_TIME__: string;

/**
 * Global legal and build-information footer.
 */
export function AppFooter() {
  const buildDateTime = new Date(__BUILD_TIME__).toLocaleString(undefined, {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

  return (
    <footer className="app-footer">
      <nav className="legal-links" aria-label="Legal">
        <Link href="/privacy">Privacy Policy</Link>
        <span className="separator" aria-hidden="true">·</span>
        <Link href="/terms">Terms of Service</Link>
        <span className="separator" aria-hidden="true">·</span>
        <a href="/storybook/" target="storybook">Storybook</a>
      </nav>
      <p className="build-info">
        {__APP_ENV__} · {__APP_VERSION__} · {__BUILD_SHA__} · {buildDateTime}
      </p>
    </footer>
  );
}
